import { render, staticRenderFns } from "./ManagerChips.vue?vue&type=template&id=a1ac3c7a"
import script from "./ManagerChips.vue?vue&type=script&lang=ts"
export * from "./ManagerChips.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1ac3c7a')) {
      api.createRecord('a1ac3c7a', component.options)
    } else {
      api.reload('a1ac3c7a', component.options)
    }
    module.hot.accept("./ManagerChips.vue?vue&type=template&id=a1ac3c7a", function () {
      api.rerender('a1ac3c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/managers/ManagerChips.vue"
export default component.exports